import type { Location } from "@remix-run/react";

export class GTMDataLayer {
	static async trackPageView(location: Location) {
		const pagePath = location.pathname + location.search;
		const pageUrl = `${window.location.origin}${pagePath}`;
		const event = {
			//TODO: why not page-view
			"event": "virtual-page-view",
			"PagePath": pagePath,
			"PageUrl": pageUrl,
			"PageTitle": document.title,
		}
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(event);
		if (window.fbq) window.fbq("track", "ViewContent");
	}
	/*
	static addToCart(product: Product | undefined, session: Session | undefined) {
		 if (!product || !session) return;
		 const event = {
			  event: "addToCart",
			  ecommerce: {
					"currencyCode": session.sourceCurrencyCode,
					add: {
						 products: [
							  {
									name: product.name,
									id: product.productId,
									price: session.faceValue,
									quantity: 1
							  }
						 ]
					}
			  }
		 };
		 // console.log(JSON.stringify(event));
		 if (window.dataLayer) {
			  window.dataLayer.push(event);
		 }
		 if (window.fbq) window.fbq("track", "AddToCart");
	}
	static checkout(product: Product | undefined, session: Session) {
		 if (!product || !session) return;
		 const event = {
			  event: "checkout",
			  ecommerce: {
					"currencyCode": session.sourceCurrencyCode,
					"checkout": {
						 actionField: { step: 1, option: "summary" },
						 products: [
							  {
									name: product.name,
									id: product.productId,
									price: session.faceValue,
									quantity: 1
							  }
						 ]
					}
			  }
		 };
		 // console.log(JSON.stringify(event));
		 if (window.dataLayer) {
			  window.dataLayer.push(event);
		 }
		 if (window.fbq) window.fbq("track", "InitiateCheckout");
	}
	static addPaymentInfo(session: Partial<Session>, paymentMethod: string) {
		 const event = {
			  event: "checkout",
			  ecommerce: {
					"currencyCode": session.sourceCurrencyCode,
					"checkout_option": {
						 actionField: { step: 1, option: "summary" },
					},
					"checkout": {
						 actionField: { step: 2, option: "payment" },
					}
			  }
		 };
		 // console.log(JSON.stringify(event));
		 if (window.dataLayer) {
			  window.dataLayer.push(event);
		 }
		 if (window.fbq) window.fbq("track", "AddPaymentInfo");
	}
	static transactionComplete(receipt: any) {
		 const event = {
			  "event": "purchase",
			  "ecommerce": {
					"currencyCode": receipt.sourceCurrencyCode,
					"purchase": {
						 "actionField": {
							  id: receipt.transactionId,
							  revenue: receipt.netCharge,
						 },
						 products: [
							  {
									name: receipt.operatorName,
									id: receipt.productId,
									price: receipt.topupAmount,
									quantity: 1
							  }
						 ]
					}
			  }
		 };
		 // console.log(JSON.stringify(event));
		 if (window.dataLayer) {
			  window.dataLayer.push(event);
		 }
		 if (window.fbq) window.fbq("track", "Purchase", { currency: receipt.sourceCurrencyCode, value: receipt.netCharge });
	}
	static login(email: string | undefined) {
		 if (!email) return;
		 const event = {
			  event: "login",
			  data: {
					userInfo: {
						 //userId: "{{userId}}", // The user id
						 emailAddress: email, // The user's email address
					}
			  }
		 };
		 if (window.dataLayer) {
			  window.dataLayer.push(event);
		 }
	}
	static register(email: string | undefined) {
		 if (!email) return;
		 const event = {
			  event: "signup",
			  data: {
					userInfo: {
						 //userId: "{{userId}}", // The user id
						 emailAddress: email, // The user's email address
					}
			  }
		 };
		 if (window.dataLayer) {
			  window.dataLayer.push(event);
		 }
	}
  */
}